(function () {
  'use strict';

  // ── Suggestion carousel ────────────────────────────────────────
  function initSuggestCarousel() {
    var suggestWrap = document.getElementById('dayumSuggestWrap');
    if (!suggestWrap) return;

    // Already rendered — just wire buttons
    if (suggestWrap.dataset.rendered === '1') {
      wireSuggestButtons(suggestWrap);
      wireNavArrows(suggestWrap);
      return;
    }

    var productId = suggestWrap.dataset.productId;
    if (!productId || productId === '0') return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          suggestWrap.style.display = 'none';
          return;
        }
        renderSuggestCards(suggestWrap, products);
      })
      .catch(function () {
        suggestWrap.style.display = 'none';
      });
  }

  function renderSuggestCards(wrap, products) {
    var track = wrap.querySelector('.dayum-suggest__track');
    if (!track) return;

    track.innerHTML = products.map(function (p) {
      var imgSrc = p.featured_image
        ? p.featured_image + '&width=200'
        : '';
      return (
        '<div class="dayum-suggest__card">' +
          '<a href="' + p.url + '" class="dayum-suggest__img">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</a>' +
          '<a href="' + p.url + '" class="dayum-suggest__name">' + (p.title || '') + '</a>' +
          '<a href="' + p.url + '" class="dayum-suggest__btn">ADD</a>' +
        '</div>'
      );
    }).join('');

    wrap.dataset.rendered = '1';
    wireNavArrows(wrap);
  }

  function wireSuggestButtons(wrap) {
    wrap.querySelectorAll('.dayum-suggest__btn:not([data-wired])').forEach(function (btn) {
      btn.dataset.wired = '1';
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        btn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added!';
            // Trigger theme cart refresh
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:update'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = 'Add';
            }, 2000);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Error';
            setTimeout(function () { btn.textContent = 'Add'; }, 1500);
          });
      });
    });
  }

  function wireNavArrows(wrap) {
    var track = wrap.querySelector('.dayum-suggest__track');
    if (!track) return;
    var prev = wrap.querySelector('.dayum-suggest__nav--prev');
    var next = wrap.querySelector('.dayum-suggest__nav--next');
    if (prev && !prev.dataset.wired) {
      prev.dataset.wired = '1';
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -156, behavior: 'smooth' });
      });
    }
    if (next && !next.dataset.wired) {
      next.dataset.wired = '1';
      next.addEventListener('click', function () {
        track.scrollBy({ left: 156, behavior: 'smooth' });
      });
    }
  }

  // ── Init ───────────────────────────────────────────────────────
  function initAll() {
    initSuggestCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Section Rendering API morphs the cart drawer content
  var _cartObserver = null;
  function attachCartObserver() {
    var target = document.querySelector('cart-drawer-component .cart-drawer__inner, .cart-drawer__inner');
    if (!target || _cartObserver) return;
    _cartObserver = new MutationObserver(function () {
      clearTimeout(_cartObserver._t);
      _cartObserver._t = setTimeout(initAll, 200);
    });
    _cartObserver.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachCartObserver);
  } else {
    attachCartObserver();
    // Retry if drawer not yet in DOM
    var _retries = 0;
    var _retryInterval = setInterval(function () {
      attachCartObserver();
      if (_cartObserver || ++_retries > 10) clearInterval(_retryInterval);
    }, 500);
  }

})();
